import { render } from "./BlockedUser.vue?vue&type=template&id=9814ccfa"
import script from "./BlockedUser.vue?vue&type=script&lang=js"
export * from "./BlockedUser.vue?vue&type=script&lang=js"

import exportComponent from "C:\\projects\\dcc\\site\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__